import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]

import IMenu from '@/js/components/molecules/IMenu.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ShopInfoButton',
  props: {
    statementForNote: {},
    openingDate: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IMenu, {
    width: "176",
    "aria-label": "メニュー"
  }, {
    link: _withCtx(() => [
      _createElementVNode("i", {
        class: _normalizeClass(["icon-dots-horizontal", _ctx.$style.button])
      }, null, 2)
    ]),
    menu: _withCtx(() => [
      (_ctx.statementForNote)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: _normalizeClass(_ctx.$style.statementForNote)
          }, [
            _createElementVNode("a", { href: _ctx.statementForNote }, "特定商法取引情報", 8, _hoisted_1)
          ], 2))
        : _createCommentVNode("", true),
      _cache[0] || (_cache[0] = _createTextVNode()),
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.$style.openingDate)
      }, "開店日：" + _toDisplayString(_ctx.openingDate), 3)
    ]),
    _: 1,
    __: [1]
  }))
}
}

})